import React, { useEffect } from 'react'
import VendorStore from '../../components/atoms/vendorStores'
import CardWrapper from '../../components/molecules/CardWrapper'
import CardHeader from '../../components/atoms/cardHeader'
import LeftItems from './components/LeftItems'
import { Col, Row } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import Store from './components/Store/Store'
import { GetCancellationPolicy, GetReturnPolicy } from '../../store/thunks/vendorStoreThunk'
import ReturnExchange from './components/ReturnExchange'
import Cancellation from './components/Cancellation'
import { GetAllProductDomains } from '../../store/thunks/sellerProductCategoriesThunk'

const StoreSetting = () => {
  const dispatch = useDispatch();
  const { storeId } = useSelector((state) => state?.storeData);

  useEffect(() => {
    dispatch(GetAllProductDomains());
    if(storeId){
      dispatch(GetReturnPolicy({ inventoryId: storeId }));
      dispatch(GetCancellationPolicy({ inventoryId: storeId }))
    }
  }, [storeId])
  return (
    <div className="content d-flex flex-column flex-column-fluid">
      <div className="container d-flex flex-sm-nowrap flex-wrap justify-content-end">
        <div className="align-items-center d-flex justify-content-end pb-6">
          <VendorStore isClearable={true} />
        </div>
      </div>

      <CardWrapper>
        <CardHeader name="Seller Store Setting" tooltipText={"Manage your store information, address, licenses, pickup options, and return or cancellation settings."} />
        <div className="card-body p-4">
          <Row gutter={[12, 12]}>
            <LeftItems />

            <Col className="gutter-row" xs={24} lg={19}>
              <div className="h-100 border border-1 border-light-dark tab-content">
                <div
                  className="tab-pane fade show active"
                  id="tab_pane_1"
                  role="tabpanel"
                  aria-labelledby="tab_pane_1"
                >
                  <Store storeId={storeId} />
                </div>
                <div
                  className="tab-pane fade"
                  id="tab_pane_6"
                  role="tabpanel"
                  aria-labelledby="tab_pane_6"
                >
                  {/* <Identification storeId={storeId} /> */}
                </div>
                <div
                  className="tab-pane fade"
                  id="tab_pane_2"
                  role="tabpanel"
                  aria-labelledby="tab_pane_2"
                >
                  {/* <Payments storeId={storeId} /> */}
                </div>
                <div
                  className="tab-pane fade"
                  id="tab_pane_3"
                  role="tabpanel"
                  aria-labelledby="tab_pane_3"
                >
                  {/* <ShippingDelivery storeId={storeId} /> */}
                </div>
                <div
                  className="tab-pane fade"
                  id="tab_pane_4"
                  role="tabpanel"
                  aria-labelledby="tab_pane_4"
                >
                  {/* <InStore storeId={storeId} /> */}
                </div>
                <div
                  className="tab-pane fade"
                  id="tab_pane_5"
                  role="tabpanel"
                  aria-labelledby="tab_pane_5"
                >
                  <ReturnExchange storeId={storeId} />
                </div>
                <div
                  className="tab-pane fade"
                  id="tab_pane_7"
                  role="tabpanel"
                  aria-labelledby="tab_pane_7"
                >
                  <Cancellation storeId={storeId} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </CardWrapper>
    </div>
  )
}

export default StoreSetting
